const { clearError, updateError } = require("helpers/errorHandling");

const validatePromoCodeForm = (formData, errors, setErrors, t, isEdit = false) => {
  let updatedErrors = [];
  let hasError = false;

  // Title — required, format check on create only
  if (!formData.title) {
    updatedErrors = updateError("title", t("validation.required"), updatedErrors);
    hasError = true;
  } else if (!isEdit && !/^[A-Za-z0-9]{1,8}$/.test(formData.title)) {
    updatedErrors = updateError(
      "title",
      t("validation.promoCodeFormat", "8 lettres et chiffres max."),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("title", updatedErrors);
  }

  // Percentage
  if (!formData.percentage || formData.percentage < 1 || formData.percentage > 100) {
    updatedErrors = updateError(
      "percentage",
      t("validation.percentageRange"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("percentage", updatedErrors);
  }

  // ------------------------------------------------------------
  // Start date — validation commented out (field hidden)
  // ------------------------------------------------------------
  // if (!formData.start_date) {
  //   if (!isEdit) {
  //     updatedErrors = updateError("start_date", t("validation.required"), updatedErrors);
  //     hasError = true;
  //   } else {
  //     updatedErrors = clearError("start_date", updatedErrors);
  //   }
  // } else {
  //   updatedErrors = clearError("start_date", updatedErrors);
  // }

  // Expiration date
  if (!formData.expiration_date) {
    updatedErrors = updateError(
      "expiration_date",
      t("validation.required"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("expiration_date", updatedErrors);
  }

  // ------------------------------------------------------------
  // Cross-check start_date <= expiration_date — commented out
  // ------------------------------------------------------------
  // if (formData.start_date && formData.expiration_date) {
  //   const start = new Date(formData.start_date);
  //   const end = new Date(formData.expiration_date);
  //   if (!isNaN(start.getTime()) && !isNaN(end.getTime()) && start > end) {
  //     updatedErrors = updateError(
  //       "expiration_date",
  //       t("validation.expirationBeforeStart"),
  //       updatedErrors
  //     );
  //     hasError = true;
  //   } else {
  //     updatedErrors = clearError("expiration_date", updatedErrors);
  //   }
  // }

  // Customer name — required on create
  if (!formData.customer_name) {
    if (!isEdit) {
      updatedErrors = updateError(
        "customer_name",
        t("validation.required"),
        updatedErrors
      );
      hasError = true;
    } else {
      updatedErrors = clearError("customer_name", updatedErrors);
    }
  } else {
    updatedErrors = clearError("customer_name", updatedErrors);
  }

  // Customer email
  if (!formData.customer_email || !/\S+@\S+\.\S+/.test(formData.customer_email)) {
    updatedErrors = updateError(
      "customer_email",
      t("validation.invalidEmail"),
      updatedErrors
    );
    hasError = true;
  } else {
    updatedErrors = clearError("customer_email", updatedErrors);
  }

  // Places — required on create
  if (!formData.places || formData.places.length === 0) {
    if (!isEdit) {
      updatedErrors = updateError("places", t("validation.required"), updatedErrors);
      hasError = true;
    } else {
      updatedErrors = clearError("places", updatedErrors);
    }
  } else {
    updatedErrors = clearError("places", updatedErrors);
  }

  // ------------------------------------------------------------
  // Description — validation removed (field no longer in form)
  // ------------------------------------------------------------
  // (no code here)

  setErrors(updatedErrors);
  return !hasError;
};

export default validatePromoCodeForm;


// const { clearError, updateError } = require("helpers/errorHandling");

// const validatePromoCodeForm = (formData, errors, setErrors, t) => {
//     let updatedErrors = [];
//     let hasError = false;
  
//     // Validate title
//     if (!formData.title) {
//       updatedErrors = updateError("title", t("validation.required"), updatedErrors);
//       hasError = true;
//     } else {
//       updatedErrors = clearError("title", updatedErrors);
//     }
  
//     // Validate percentage
//     if (!formData.percentage || formData.percentage < 1 || formData.percentage > 100) {
//       updatedErrors = updateError(
//         "percentage",
//         t("validation.percentageRange"),
//         updatedErrors
//       );
//       hasError = true;
//     } else {
//       updatedErrors = clearError("percentage", updatedErrors);
//     }
  
//     // Validate expiration date
//     if (!formData.expiration_date) {
//       updatedErrors = updateError(
//         "expiration_date",
//         t("validation.required"),
//         updatedErrors
//       );
//       hasError = true;
//     } else {
//       updatedErrors = clearError("expiration_date", updatedErrors);
//     }
  
//     // Validate customer email
//     if (!formData.customer_email || !/\S+@\S+\.\S+/.test(formData.customer_email)) {
//       updatedErrors = updateError(
//         "customer_email",
//         t("validation.invalidEmail"),
//         updatedErrors
//       );
//       hasError = true;
//     } else {
//       updatedErrors = clearError("customer_email", updatedErrors);
//     }
  
//     // Validate description
//     if (!formData.description) {
//       updatedErrors = updateError(
//         "description",
//         t("validation.required"),
//         updatedErrors
//       );
//       hasError = true;
//     } else {
//       updatedErrors = clearError("description", updatedErrors);
//     }
  
//     // Set the errors state
//     setErrors(updatedErrors);
  
//     // Return whether there are any errors
//     return !hasError;
//   };

//   export default validatePromoCodeForm;